import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search';
import { type UIAnalyticsEvent, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useQueryParams } from '@atlassian/jira-software-router-utils/src/services/query-params/index.tsx';
import { QUERY_PARAM_SEARCH } from '../../common/constants';

const Search = () => {
	const [queryParams, setQueryParams] = useQueryParams(QUERY_PARAM_SEARCH);
	const [currentStr, setCurrentStr] = useState<string>(queryParams[QUERY_PARAM_SEARCH]);

	const handleInputChange = debounce((searchStr: string, analyticsEvent: UIAnalyticsEvent) => {
		setCurrentStr(searchStr);
		setQueryParams({ [QUERY_PARAM_SEARCH]: searchStr });
		fireUIAnalytics(analyticsEvent, 'textFilterFilterSearch', {
			length: searchStr.length,
		});
	}, 300);

	// @ts-expect-error - Type '{ onChange: DebouncedFunc<(searchStr: string, analyticsEvent: UIAnalyticsEvent) => void>; value: string; isAlwaysExpanded: true; }' is missing the following properties from type 'Omit<{ value: string; placeholder: string; describedById?: string | undefined; hasAutoFocus: boolean; isCompact: boolean; onChange: (value: string, args_1: UIAnalyticsEvent) => void; ... 6 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>': placeholder, hasAutoFocus, isCompact, increasedWidth, placeholderAlwaysVisible
	return <FilterSearch onChange={handleInputChange} value={currentStr || ''} isAlwaysExpanded />;
};

export default Search;
